var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"variant":"danger","block":""},on:{"click":_vm.reset}},[_c('b-icon-box-arrow-left'),_vm._v(" Reset App")],1)}
var staticRenderFns = []

export { render, staticRenderFns }